import { render, staticRenderFns } from "./wuXingXq.vue?vue&type=template&id=f0f13cca&"
import script from "./wuXingXq.vue?vue&type=script&lang=js&"
export * from "./wuXingXq.vue?vue&type=script&lang=js&"
import style0 from "./wuXingXq.vue?vue&type=style&index=0&id=f0f13cca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports